import { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

const Input = (props: ComponentProps<'input'>) => {
  const { className, type, ...restProps } = props;

  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border-2 bg-transparent px-3 py-1 text-base shadow-xs ring-0 transition-colors outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-primary',
        'aria-invalid:border-destructive',
        className,
      )}
      {...restProps}
    />
  );
};

export { Input };
